<ng-container *ngTemplateOutlet="toolbarService.toolbarContent$ | async"></ng-container>